// extracted by mini-css-extract-plugin
export default {"Box":"borderless-text-input-module__Box--JIRZz"};